import { bulletType } from '../assets/data/enum';
import Gun from '../managers/Gun';
export default class Bullet extends Phaser.GameObjects.Image {
    public body: Phaser.Physics.Arcade.Body;
    public hitValue: number = 25;
    private _move: Function;
    private _gun: Gun;
    private _checkBoundary: Function;
    private _shoot_audio: Phaser.Sound.BaseSound;
    public tag: string;

    private _updateCounter: number;
    private _updateCounterMax: number;
    constructor(scene: Phaser.Scene, x: number, y: number, key: string, frame?: string) {
        super(scene, x, y, key, frame);
        this.tag = frame;
        scene.add.existing(this);
        this.setOrigin(0.5, 0.5);
        // this._shoot_audio = this.scene.sound.add("shoot", {
        //     loop: false,
        //     volume: (window.constants["VOLUME"] * 0.4)
        // });
        this._initPhysics();
        this._updateCounter = 10;
        this._updateCounterMax = 10;
        this.stop();
    }

    private _initPhysics(): void {
        this.scene.physics.world.enable(this);
        this.body.setAllowGravity(false);
        this.body.setAllowDrag(false);
        if(!this.tag.includes("player")){
            this.body.setSize(this.width * 0.7, this.height * 0.8);
        }
        // this.body.moves = false
    }

    private _checkLeftRightBottom() {
        if (this.x > this._gun.boundary.r || this.x < this._gun.boundary.l || this.y > this._gun.boundary.b) {
            return true;
        }
        return false;
    }

    private _checkTop() {
        if (this.y < this._gun.boundary.t) {
            return true;
        }
        return false;
    }

    private _checkAllDirections() {
        if (this.x > this._gun.boundary.r || this.x < this._gun.boundary.l || this.y > this._gun.boundary.b || this.y < this._gun.boundary.t) {
            return true;
        }
        return false;
    }

    private _moveOffScreen() {
        this.x = window.constants.BASE_WIDTH + 100;
        this.y = window.constants.BASE_HEIGHT + 600;
        this.body.x = window.constants.BASE_WIDTH + 100;
        this.body.y = window.constants.BASE_HEIGHT + 600;
    }

    private _moveVertical(angle: number) {
        this.setAngle(angle);
        this.body.setVelocityY(this._gun.speed);
    }

    private _moveTowardsTarget(a, x, y) {
        let angle = this.scene.physics.moveTo(this, x, y, this._gun.speed);
        this.setRotation((-(Math.PI / 2) * 3) + angle);
    }

    private _moveInAngle(angle: number) {
        this.setAngle(90 + angle);
        this.scene.physics.velocityFromAngle(angle, this._gun.speed, this.body.velocity);
    }

    public reset(x, y) {
        this.body.reset(x, y);
    }

    public setProperties(gun: Gun, count: number) {
        this._gun = gun;
        this.name = gun.name + "_" + count;
        this.setBulletType();
    }

    public setBulletType() {
        this.hitValue = this._gun.hitValue;
        switch (this._gun.type) {
            case bulletType.player:
                this._move = this._moveVertical;
                this._checkBoundary = this._checkTop;
                this.setScale(1);
                break;
            case bulletType.buggy:
            case bulletType.battle_truck:
            case bulletType.tank:
                // this.setTint(0xff0000);
                this._move = this._moveTowardsTarget;
                this._checkBoundary = this._checkLeftRightBottom;
                this.setScale(2);
                break;
            case bulletType.split_shooter:
                this._move = this._moveInAngle;
                this._checkBoundary = this._checkAllDirections;
                this.setScale(1);
                break;
        }
    }

    private _startPhysics() {
        this.body.setEnable(true);
        this.scene.physics.world.enable(this);
    }

    private _stopPhysics() {
        this.body.stop();
        this.body.setEnable(false);
        this.scene.physics.world.disable(this);
    }

    // only moveTowradsTarget will read the x and y values, and moveVertical + moveInAngle will only read angle 
    public move(angle?: number, x?: number, y?: number) {
        if (this.scale == 1) {
            if (this._gun.type == bulletType.player || this._gun.type == bulletType.split_shooter) {
                this.setScale(1);
            }
        }
        this.setActive(true);
        this.setVisible(true);
        this._startPhysics();
        // this._shoot_audio.play();
        this._move(angle, x , y);
    }

    public stop() {
        this._stopPhysics();
        this.setActive(false);
        this.setVisible(false);
        this._moveOffScreen();
    }

    update() {
        if(!this._updateCounter--){
            this._updateCounter = this._updateCounterMax;
            if (this._checkBoundary()) {
                this.stop();
            }
        }
    }

}